<template>
  <div class="main_view">
    <!--导航栏-->
    <div class="report_head">
        <img src="/static/images/bigdata/maoyan_logo.png"/>
    </div>
    <!--二维码-->
    <div class="service">
      <img src="/static/maozhou_wechat.jpg">
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  mounted: {
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

.main_view
  background-color $brand-bgm
  display flex
  flex-direction column
  width 100%
  .report_head
    width 100%
    margin 0 auto
    background-color $white
    height 75px
    box-shadow 0px 1px 8px 0px rgba(0,0,0,0.1)
    display flex
    flex-direction row
    align-items center
    img
      margin 0 auto
      width 185px
      height auto

  .service
    padding-top 10px
    display flex
    width 100%
    max-width 300px
    margin 0 auto
    height auto
    img
      width 100%
      height auto

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue